export default __webpack_public_path__ + "static/media/hero.9b9a684d.png";